var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"type":"image/svg+xml","data":_vm.src,"lazy":_vm.src,"alt":_vm.alt},on:{"load":_vm.setComplete}})}
var staticRenderFns = []

export { render, staticRenderFns }